import React from 'react';
import { Switch } from 'react-router-dom';

import { Route, hasPermission } from '@sopranodesign/pulse-auth';

import { RecordedMetrics } from '../Pages/index';

const routes = [
  {
    name: 'Metric Overview',
    path: '/dashboard/:id',
    component: RecordedMetrics,
    canAccess: hasPermission('view metrics')
  }
];

const MetricRouter = () => {
  return (
    <Switch>
      {routes.map((route, key) => (
        <Route
          exact={route.exact ?? true}
          public={false}
          key={key}
          path={route.path}
          canAccess={route.canAccess}
          render={props => <route.component {...props} />}
        />
      ))}
    </Switch>
  );
};

export default MetricRouter;
